
<div class="d-flex align-items-center p-2" *ngIf="loading">
    <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
    <span class="ml-2">Please wait while loading Package Details ...</span>
</div>
<div class="package-charges-loading" *ngIf="loadingCharges">
    <div class="d-flex align-items-center bg-white p-2">
        <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
        <span class="ml-2">Please wait while loading Charges ...</span>
    </div>
</div>
<div class="mh-355 p-2 position-relative" *ngIf="!loading && !packageInfo">
    <no-data [title]="'Package Details'"></no-data>
</div>
<div class="row" *ngIf="!loading && packageInfo && !isShow && !showReport">
    <div class="col-12">
        <h5 class="card-header p-2 bg-light heading2 d-flex justify-content-between align-items-center" [class.border-radius-none]="!isCounselling" [class.bgr]="isCounselling">
            <div>
                <div class="font-16 mb-1">
                    <span *ngIf="!packageInfo.packageModule?.packageName" [textContent]="'Package Preview'"></span>
                    <ng-container *ngIf="packageInfo.packageModule?.packageName">
                        <span [class.text-primary]="!isCounselling" class="text-capitalize" [textContent]="packageInfo.packageModule?.packageName"></span>
                        <ng-container *ngIf="packageInfo.packageModule?.payType && packageInfo.packageModule?.packageType">
                            <span class="ml-1 font-13" [class.text-mute]="!isCounselling" [textContent]="'(' + (packageInfo.packageModule.payType | payType) + ' / '"></span>
                            <span class="font-13" [class.text-mute]="!isCounselling" [textContent]="(packageInfo.packageModule.packageType | packageType) + ')'"></span>
                        </ng-container>
                    </ng-container>
                </div>
                <div class="font-13">
                    <span [textContent]="packageInfo.packageModule.locationName"></span>
                    <small class="text-mute ml-1" [textContent]="'(' + packageInfo.packageModule.templateName + ')'"></small>
                </div>
            </div>
            <div class="text-mute font-weight-normal font-13 d-flex flex-column">
                <div class="mb-1 d-flex align-items-center" *ngIf="packageInfo.packageModule?.providerName">
                    <span class="text-dark" style="width: 70px; display: inline-block;">Doctor</span>
                    <div class="text-capitalize">
                        <span [textContent]="packageInfo.packageModule.providerName"></span>
                        <small class="ml-1" [textContent]="'(' + packageInfo.packageModule.departmentName + ')'"></small>
                    </div>
                </div>
                <div class=" d-flex align-items-center" *ngIf="packageInfo.packageModule?.expiresIn">
                    <span class="text-dark" style="width: 70px; display: inline-block;">Expires in</span>
                    <div>
                        <span [textContent]="packageInfo.packageModule.expiresIn"></span>
                        <span class="ml-1" [textContent]="'days'"></span>
                    </div>
                </div>
            </div>
        </h5>
        <div class="pt-2" [class.px-2]="!isCounselling" [class.px-0]="!isCounselling">
            <div *ngIf="!chargeCategory" class="mb-2">
                <div class="d-flex align-items-center" *ngIf="loadingChargeCategories">
                    <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
                    <span class="ml-2">Please wait while loading Package Cost Details ...</span>
                </div>
                <ng-container *ngIf="!loadingChargeCategories && chargeCategories?.length">
                    <label class="mb-1 font-13 font-weight-bold text-primary font-13">Charge Categories</label>
                    <div class="package-details-container">
                        <table class="table table-centered table-sm mb-0">
                            <thead class="thead-no-bdr font-13">
                                <tr>
                                    <th>Charge Category</th>
                                    <th style="width: 180px" class="text-right">Sub Total</th>
                                    <th style="width: 180px" class="text-right">Discount</th>
                                    <th style="width: 180px" class="text-right">Total</th>
                                    <th class="text-right"></th>
                                </tr>
                            </thead>
                            <tbody class="font-13">
                                <tr *ngFor="let item of chargeCategories; let i = index;">
                                    <td style="width: 40%" class="pl-0 font-weight-semibold" [class.border-0]="i === 0">
                                        <span [textContent]="item.name"></span>
                                    </td>
                                    <td class="text-right" [class.border-0]="i === 0">
                                        <span [textContent]="item.subTotal | currency :'₹ ':'symbol':'1.2-2'"></span>
                                    </td>
                                    <td class="text-right" [class.border-0]="i === 0">
                                        <span [textContent]="item.discount | currency :'₹ ':'symbol':'1.2-2'"></span>
                                    </td>
                                    <td class="text-right" [class.border-0]="i === 0">
                                        <span [textContent]="item.total | currency :'₹ ':'symbol':'1.2-2'"></span>
                                    </td>
                                    <td [class.border-0]="i === 0" style="width: 50px" class="text-right pr-0">
                                        <a class="text-primary cursor-pointer" (click)="onSelectChargeCategory(item.id)"><i class="fe-eye"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-container>
            </div>
            <div class="mb-1 w-100 font-13 d-flex align-items-end justify-content-between" *ngIf="showChargeCategories">
                <label class="font-weight-bold mb-0 text-primary">Package Details</label>
                <div class="d-flex align-items-center" *ngIf="chargeCategory">
                    <span class="text-muted mr-1">Charge Category : </span>
                    <ng-select class="ng-select-28px" [items]="chargeCategories" [loading]="loadingChargeCategories" [clearable]="true" bindLabel="name" placeholder="Select Charge Category" [(ngModel)]="chargeCategory" (change)="onSelectChargeCategory($event.id)" (clear)="onClearChargeCategory();">
                        <ng-template ng-option-tmp let-item="item">
                            <span class="font-weight-semibold font-11" [textContent]="item.name"></span>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="font-weight-semibold font-11" [textContent]="item.name"></span>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="mb-1 w-100 font-13 d-flex align-items-end justify-content-between" *ngIf="!showChargeCategories">
                <label class="font-weight-bold mb-0 font-12" [textContent]="chargeCategory.name"></label>
                <div *ngIf="!hidePrice && isCounselling" class="form-check form-check-primary">
                    <input class="form-check-input rounded-circle" [(ngModel)]="hidePrices" type="checkbox" id="chkHidePrices">
                    <label class="form-check-label" for="chkHidePrices">Hide Prices</label>
                </div>
            </div>
            <div class="package-details-container" [class.mb-2]="!isCounselling" *ngIf="packageInfo.modules?.length">
                <div class="package-details-section" *ngFor="let md of packageInfo.modules;">
                    <span class="package-module-title" [textContent]="md.moduleName"></span>
                    <table class="table table-centered table-light-border mb-0">
                        <tbody>
                            <tr [class.strike-item]="item.isNA" *ngFor="let item of fetchPackageDetails(md.modulesMasterId);">
                                <td style="width: 30px" [textContent]="item.quantity"></td>
                                <td *ngIf="md.isChargeCategoryApplicable" [textContent]="item.chargeName || '-'"></td>
                                <td *ngIf="!md.isChargeCategoryApplicable && md.packageType === packageType.Limit" [textContent]="md.moduleName + ' Amount'"></td>
                                <td *ngIf="!md.isChargeCategoryApplicable && md.packageType === packageType.Quantity" [textContent]="'No.of ' + md.moduleName"></td>
                                <td style="width: 90px" *ngIf="item.repeatTypeName && md.isChargeCategoryApplicable">
                                    <small [textContent]="item.repeatTypeName" class="text-muted"></small>
                                </td>
                                <td class="text-right" style="width: 135px" *ngIf="!hidePrices">
                                    <span *ngIf="!item.isFree && chargeCategory" [textContent]="(item.amount || 0) | currency :'₹ ':'symbol':'1.2-2'"></span>
                                    <small *ngIf="item.isFree">Free <span class="font-10 text-muted" *ngIf="chargeCategory" [textContent]="'(' + ((item.amount || 0) | currency :'₹ ':'symbol':'1.2-2') + ')'"></span></small>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <table class="table table-centered table-responsive mb-0 mt-2 table-borderless font-13">
                    <tbody>
                        <tr *ngIf="packageInfo.packageModule?.exclusions" class="h-32 col-12">
                            <td style="width: 135px" class="pl-0 font-weight-bold">Exclusions</td>
                            <td>
                                <span class="mb-0 break-all" [textContent]="packageInfo.packageModule.exclusions"></span>
                            </td>
                        </tr>
                        <tr *ngIf="packageInfo.packageModule?.notes" class="h-32 col-12">
                            <td class="pl-0 pt-0 font-weight-bold">Package Notes</td>
                            <td class="pt-0">
                                <span class="mb-0 break-all" [textContent]="packageInfo.packageModule.notes"></span>
                            </td>
                        </tr>
                        <tr *ngIf="packageInfo.packageModule?.comments" class="h-32 col-12">
                            <td class="pl-0 pt-0 font-weight-bold">Comments</td>
                            <td class="pt-0">
                                <p class="mb-0 pre-line break-all" [textContent]="packageInfo.packageModule.comments"></p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table table-centered package-amounts" *ngIf="!isCounselling">
                    <tbody>
                        <ng-container *ngIf="!chargeCategory">
                            <tr>
                                <td>Total Quantity</td>
                                <td [textContent]="packageInfo.packageModule.quantity"></td>
                            </tr>
                            <tr>
                                <td>Discount</td>
                                <td [textContent]="packageInfo.packageModule.discountPercentage ? packageInfo.packageModule.discountPercentage + '%' : ((packageInfo.packageModule.discountAmount || 0) | currency :'₹ ':'symbol':'1.2-2')"></td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="chargeCategory">
                            <tr>
                                <td>Total Quantity</td>
                                <td *ngIf="packageInfo.packageModule.quantity !== packageInfo.totalQuantity">
                                    <span [textContent]="packageInfo.totalQuantity"></span>
                                    <small class="font-11" [textContent]="' / ' + packageInfo.packageModule.quantity"></small>
                                </td>
                                <td *ngIf="packageInfo.packageModule.quantity === packageInfo.totalQuantity" [textContent]="packageInfo.totalQuantity"></td>
                            </tr>
                            <tr>
                                <td>Sub Total</td>
                                <td [textContent]="packageInfo.subTotal | currency :'₹ ':'symbol':'1.2-2'"></td>
                            </tr>
                            <tr class="text-success">
                                <td>Discount</td>
                                <td [textContent]="packageInfo.discount | currency :'₹ ':'symbol':'1.2-2'"></td>
                            </tr>
                            <tr class="font-weight-bold font-15">
                                <td>Total</td>
                                <td [textContent]="packageInfo.total | currency :'₹ ':'symbol':'1.2-2'"></td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<div class="row" *ngIf="!loading && packageInfoAll && isShow && !showReport">
    <div class="col-12">
        <div *ngIf="packageInfoAll.length">
            <div *ngFor="let pack of packageInfoAll">
                <span class="package-module-title" [textContent]="pack.packageModule.packageName"></span>
                <div class="package-details-container" [class.mb-2]="!isCounselling" *ngIf="pack.modules?.length">
                    <div class="package-details-section" *ngFor="let md of pack.modules;">
                        <span class="package-module-title" [textContent]="md.moduleName"></span>
                        <div *ngIf="md.moduleName==='OT'">
                            <div *ngFor="let item of fetchPackageDetailsAll(md.modulesMasterId,pack)">
                                <table class="table table-centered table-light-border mb-0">
                                    <thead>
                                        <tr>
                                            <th style="width: 30px">Service Date</th>
                                            <th style="width: 30px">Service Name</th>
                                            <th style="width: 30px">Cost</th>
                                            <th style="width: 30px">Count</th>
                                            <th class="text-right" style="width: 135px">Amount</th>
                                            <th class="text-right" style="width: 35px">Sub Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style="width: 30px" [textContent]="item.createdDate |  date :'dd/MM/yyyy'"></td>
                                            <td style="width: 30px" [textContent]="item.chargeName || '-'"></td>
                                            <td  [textContent]="item.serviceTotal"></td>
                                            <td style="width: 30px">1</td>
                                            <td class="text-right" style="width: 135px" [textContent]="item.serviceTotal"></td>
                                            <td class="text-right" style="width: 35px" [textContent]="item.serviceTotal"></td>
                                        </tr>
                                        <tr *ngFor="let itemService of fetchSurgeries(item.referenceId)">
                                            <td style="width: 30px" [textContent]="item.createdDate |  date :'dd/MM/yyyy'"></td>
                                            <td style="width: 30px" [textContent]="itemService.service"></td>
                                            <td  [textContent]="itemService.amount"></td>
                                            <td  style="width: 30px">1</td>
                                            <td  class="text-right" style="width: 135px" [textContent]="itemService.amount"></td>
                                            <td  class="text-right" style="width: 35px" [textContent]="itemService.amount"></td>
                                        </tr>
                                </table>
                            </div>
                        </div>
                        <div *ngIf="md.moduleName!='OT'">
                            <table class="table table-centered table-light-border mb-0">
                                <thead>
                                    <tr>
                                        <th style="width: 30px">Service Date</th>
                                        <th style="width: 30px">Service Name</th>
                                        <th style="width: 30px">Cost</th>
                                        <th style="width: 30px">Count</th>
                                        <th class="text-right" style="width: 135px">Amount</th>
                                        <th class="text-right" style="width: 35px">Sub Total</th>
                                    </tr>

                                </thead>
                                <tbody>
                                    <tr [class.strike-item]="item.isNA" *ngFor="let item of fetchPackageDetailsAll(md.modulesMasterId,pack)">

                                        <td style="width: 30px" [textContent]="item.createdDate |  date :'dd/MM/yyyy'"></td>
                                        <td style="width: 30px" *ngIf="md.isChargeCategoryApplicable" [textContent]="item.chargeName || '-'"> </td>
                                        <td style="width: 35px" *ngIf="!hidePrices">
                                            <span *ngIf="!item.isFree && chargeCategory" [textContent]="(item.amount || 0) | currency :'₹ ':'symbol':'1.2-2'"></span>
                                            <small *ngIf="item.isFree">Free <span class="font-10 text-muted" *ngIf="chargeCategory" [textContent]="'(' + ((item.amount || 0) | currency :'₹ ':'symbol':'1.2-2') + ')'"></span></small>
                                        </td>
                                        <td style="width: 30px" *ngIf="!md.isChargeCategoryApplicable && md.packageType === packageType.Quantity" [textContent]="'No.of ' + md.moduleName"></td>
                                        <td *ngIf="!md.isChargeCategoryApplicable && md.packageType === packageType.Limit" [textContent]="md.moduleName + ' Amount'"></td>
                                        <td style="width: 30px" [textContent]="item.quantity"></td>
                                        <td class="text-right" style="width: 135px" *ngIf="!hidePrices" [textContent]=(item.amount*item.quantity)></td>
                                        <td class="text-right" style="width: 35px" [textContent]="(item.amount*item.quantity)"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <table class="table table-centered table-responsive mb-0 mt-2 table-borderless font-13">
                            <tbody>
                                <tr *ngIf="pack.packageModule?.exclusions" class="h-32 col-12">
                                    <td style="width: 135px" class="pl-0 font-weight-bold">Exclusions</td>
                                    <td>
                                        <span class="mb-0 break-all" [textContent]="pack.packageModule.exclusions"></span>
                                    </td>
                                </tr>
                                <tr *ngIf="pack.packageModule?.notes" class="h-32 col-12">
                                    <td class="pl-0 pt-0 font-weight-bold">Package Notes</td>
                                    <td class="pt-0">
                                        <span class="mb-0 break-all" [textContent]="pack.packageModule.notes"></span>
                                    </td>
                                </tr>
                                <tr *ngIf="pack.packageModule?.comments" class="h-32 col-12">
                                    <td class="pl-0 pt-0 font-weight-bold">Comments</td>
                                    <td class="pt-0">
                                        <p class="mb-0 pre-line break-all" [textContent]="pack.packageModule.comments"></p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                    </div>
                    <table class="table table-centered package-amounts" *ngIf="!isCounselling">
                        <tbody>
                            <ng-container *ngIf="!chargeCategory">
                                <tr>
                                    <td>Total Quantity</td>
                                    <td [textContent]="pack.packageModule.quantity"></td>
                                </tr>
                                <tr>
                                    <td>Discount</td>
                                    <td [textContent]="pack.packageModule.discountPercentage ? pack.packageModule.discountPercentage + '%' : ((pack.packageModule.discountAmount || 0) | currency :'₹ ':'symbol':'1.2-2')"></td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="chargeCategory">
                                <tr>
                                    <td>Total Quantity</td>
                                    <td *ngIf="pack.packageModule.quantity !== pack.totalQuantity">
                                        <span [textContent]="pack.totalQuantity"></span>
                                        <small class="font-11" [textContent]="' / ' + pack.packageModule.quantity"></small>
                                    </td>
                                    <td *ngIf="pack.packageModule.quantity === pack.totalQuantity" [textContent]="pack.totalQuantity"></td>
                                </tr>
                                <tr>
                                    <td>Sub Total</td>
                                    <td [textContent]="pack.subTotal | currency :'₹ ':'symbol':'1.2-2'"></td>
                                </tr>
                                <tr class="text-success">
                                    <td>Discount</td>
                                    <td [textContent]="pack.discount | currency :'₹ ':'symbol':'1.2-2'"></td>
                                </tr>
                                <tr class="font-weight-bold font-15">
                                    <td>Total</td>
                                    <td [textContent]="pack.total | currency :'₹ ':'symbol':'1.2-2'"></td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="showReport">
    <div class="package-details-container" [class.mb-2]="!isCounselling" *ngIf="packageInfo.modules?.length">
        <div class="package-details-section" *ngFor="let md of packageInfo.modules;">
            <span class="package-module-title" [textContent]="md.moduleName"></span>
            <table class="table table-centered table-light-border mb-0">
                <tbody>

                    <tr [class.strike-item]="item.isNA" *ngFor="let item of fetchPackageDetails(md.modulesMasterId);">
                        <td class="td-width" [textContent]="item.quantity"></td>
                        <td *ngIf="md.isChargeCategoryApplicable" [textContent]="item.chargeName || '-'"></td>
                        <td *ngIf="!md.isChargeCategoryApplicable && md.packageType === packageType.Limit" [textContent]="md.moduleName + ' Amount'"></td>
                        <td *ngIf="!md.isChargeCategoryApplicable && md.packageType === packageType.Quantity" [textContent]="'No.of ' + md.moduleName"></td>
                        <td class="td-second-width" *ngIf="item.repeatTypeName && md.isChargeCategoryApplicable">
                            <small [textContent]="item.repeatTypeName" class="text-muted"></small>
                        </td>
                        <td class="text-right" style="width: 135px" *ngIf="!hidePrices">
                            <span *ngIf="!item.isFree && chargeCategory" [textContent]="(item.amount || 0) | currency :'₹ ':'symbol':'1.2-2'"></span>
                            <small *ngIf="item.isFree"><span class="font-10 text-muted" *ngIf="chargeCategory" [textContent]="'(' + ((item.amount || 0) | currency :'₹ ':'symbol':'1.2-2') + ')'"></span></small>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <table class="table table-centered table-responsive mb-0 mt-2 table-borderless font-13">
            <tbody>
                <tr *ngIf="packageInfo.packageModule?.exclusions" class="h-32 col-12">
                    <td class="pl-0 font-weight-bold third-width">Exclusions</td>
                    <td>
                        <span class="mb-0 break-all" [textContent]="packageInfo.packageModule.exclusions"></span>
                    </td>
                </tr>
                <tr *ngIf="packageInfo.packageModule?.notes" class="h-32 col-12">
                    <td class="pl-0 pt-0 font-weight-bold">Package Notes</td>
                    <td class="pt-0">
                        <span class="mb-0 break-all" [textContent]="packageInfo.packageModule.notes"></span>
                    </td>
                </tr>
                <tr *ngIf="packageInfo.packageModule?.comments" class="h-32 col-12">
                    <td class="pl-0 pt-0 font-weight-bold">Comments</td>
                    <td class="pt-0">
                        <p class="mb-0 pre-line break-all" [textContent]="packageInfo.packageModule.comments"></p>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="table table-centered package-amounts" *ngIf="!isCounselling">
            <tbody>
                <ng-container *ngIf="chargeCategory">
                    <tr>
                        <td>Total Quantity</td>
                        <td *ngIf="packageInfo.packageModule.quantity !== packageInfo.totalQuantity">
                            <span [textContent]="packageInfo.totalQuantity"></span>
                            <small class="font-11" [textContent]="' / ' + packageInfo.packageModule.quantity"></small>
                        </td>
                        <td *ngIf="packageInfo.packageModule.quantity === packageInfo.totalQuantity" [textContent]="packageInfo.totalQuantity"></td>
                    </tr>
                    <tr>
                        <td>Sub Total</td>
                        <td [textContent]="packageInfo.subTotal | currency :'₹ ':'symbol':'1.2-2'"></td>
                    </tr>
                    <tr class="text-success">
                        <td>Discount</td>
                        <td [textContent]="packageInfo.discount | currency :'₹ ':'symbol':'1.2-2'"></td>
                    </tr>
                    <tr class="font-weight-bold font-15">
                        <td>Total</td>
                        <td [textContent]="packageInfo.total | currency :'₹ ':'symbol':'1.2-2'"></td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
     